import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../service/helper/reduxHelper';
import { IFrequentlyAskedQuestion } from '../../@types/model/frequentlyAskedQuestions/frequentlyAskedQuestion';

export default class FrequentlyAskedQuestionActions {
    public static setIsLoading = createAction('FAQ_SET_LOADING', withPayloadType<boolean>());
    public static setFrequentlyAskedQuestionData = createAction('FAQ_SET_LIST', withPayloadType<Array<IFrequentlyAskedQuestion> | null>());
    public static reset = createAction('FAQ_RESET');
}
